let recaptchaLoaded = false;
export const loadReCaptcha = async (siteKey: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (recaptchaLoaded) {
      return resolve();
    }

    const existingScript = document.querySelector(
      `script[src*="recaptcha/api.js"]`,
    );
    if (existingScript) {
      recaptchaLoaded = true;
      return resolve();
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      recaptchaLoaded = true;
      resolve();
    };

    script.onerror = () => reject('Erro ao carregar o script do reCAPTCHA.');

    document.head.appendChild(script);
  });
};
